export enum AccountApi {
  search = '/account/search',
  getAccounts = '/account/restrictedSearch',
  getCustomer = '/account/:customerId',
  getAddresses = '/address/:addressId'
}

export enum PriceGroupApi {
  GroupDetails = '/pricing-groups/:id',
  GetPriceGroups = '/pricing-groups/search',
  GetPriceGroups2 = '/pricing-groups/pricing'
}
